<template>
  <SessionsBase>
    <SessionsList view-name="Demos" :slug="slug" />
  </SessionsBase>
</template>

<script>
import baseSessionsMixin from '@/mixins/baseSessionsMixin'

export default {
  mixins: [baseSessionsMixin],

  mounted() {
    const tags = this.$route.query.tags
    if (tags) {
      tags
        .split(',')
        .forEach(tag => this.$store.dispatch('videos/setSelectedTag', tag))
    }

    // Set title and text
    this.$store.dispatch('sections/fetchDemoSectionsText')
    // Set sections and highlight current section
    this.$store.dispatch('sections/fetchDemoSectionsList')
    // Set videos list
    this.$store.dispatch('videos/fetchDemosList', { slug: this.slug })
    // Set action to call when filtering videos
    this.$store.commit('videos/setVideosAction', 'fetchDemosList')
  },
}
</script>
